class StickyBuyBar extends HTMLElement {
  naturalTop = 0;
  #initialized = false;

  // Moving this element between its original spot and <body> (see #stick/#unstick)
  // causes the browser to fire disconnectedCallback + connectedCallback again on every
  // move, even though it's the same node. Guard against re-running setup each time —
  // otherwise `nextElementSibling` reads null once it's the last child of body, and
  // re-initializing would silently drop the scroll listener for good.
  connectedCallback() {
    if (this.#initialized) return;
    this.#initialized = true;

    this.placeholder = this.nextElementSibling;
    if (!this.placeholder || !this.placeholder.hasAttribute('data-sticky-buy-bar-placeholder')) return;

    this.#measure();

    window.addEventListener('scroll', this.#handleScroll, { passive: true });
    window.addEventListener('resize', this.#measure);
  }

  #measure = () => {
    const wasStuck = this.classList.contains('is-stuck');
    if (wasStuck) this.#unstick();

    const rect = this.getBoundingClientRect();
    this.naturalTop = rect.top + window.scrollY;
    this.placeholder.style.height = `${this.offsetHeight}px`;

    this.#handleScroll();
  };

  #headerHeight = () => {
    const value = getComputedStyle(document.body).getPropertyValue('--header-height');
    return parseFloat(value) || 0;
  };

  // Moving to <body> while stuck escapes any ancestor that would otherwise trap
  // `position: fixed` inside its own containing block (transform/filter/contain),
  // which silently breaks fixed positioning regardless of z-index.
  #stick = () => {
    if (this.classList.contains('is-stuck')) return;
    document.body.appendChild(this);
    this.classList.add('is-stuck');
    this.placeholder.classList.add('is-active');
  };

  #unstick = () => {
    if (!this.classList.contains('is-stuck')) return;
    this.placeholder.insertAdjacentElement('beforebegin', this);
    this.classList.remove('is-stuck');
    this.placeholder.classList.remove('is-active');
  };

  #handleScroll = () => {
    const shouldStick = window.scrollY + this.#headerHeight() >= this.naturalTop;

    if (shouldStick) {
      this.#stick();
    } else {
      this.#unstick();
    }
  };
}

if (!customElements.get('sticky-buy-bar')) {
  customElements.define('sticky-buy-bar', StickyBuyBar);
}
